'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.joinTeam = exports.createTeam = exports.fetchTeam = exports.fetchTeams = exports.deserializeTeam = undefined;

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var deserializeTeam = exports.deserializeTeam = function deserializeTeam(team) {
  return {
    id: team.id,
    leader: team.leader_id,
    name: team.name,
    pages: team.page_ids,
    raised: null,
    slug: null
  };
};

var fetchTeams = exports.fetchTeams = function fetchTeams(_ref) {
  var _ref$token = _ref.token,
      token = _ref$token === undefined ? (0, _params.required)() : _ref$token;

  return (0, _client.get)('api/v2/teams', {}, {}, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  }).then(function (response) {
    return response.teams;
  });
};

var fetchTeam = exports.fetchTeam = function fetchTeam(_ref2) {
  var _ref2$id = _ref2.id,
      id = _ref2$id === undefined ? (0, _params.required)() : _ref2$id,
      _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token;

  return (0, _client.get)('api/v2/teams/' + id, {}, {}, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  }).then(function (response) {
    return response.team;
  });
};

var createTeam = exports.createTeam = function createTeam(_ref3) {
  var _ref3$token = _ref3.token,
      token = _ref3$token === undefined ? (0, _params.required)() : _ref3$token,
      _ref3$page = _ref3.page,
      page = _ref3$page === undefined ? (0, _params.required)() : _ref3$page,
      name = _ref3.name;

  return (0, _client.post)('api/v2/teams', {
    individual_page_id: page,
    name: name
  }, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  }).then(function (response) {
    return response.page;
  });
};

var joinTeam = exports.joinTeam = function joinTeam(_ref4) {
  var _ref4$id = _ref4.id,
      id = _ref4$id === undefined ? (0, _params.required)() : _ref4$id,
      _ref4$page = _ref4.page,
      page = _ref4$page === undefined ? (0, _params.required)() : _ref4$page,
      _ref4$token = _ref4.token,
      token = _ref4$token === undefined ? (0, _params.required)() : _ref4$token;

  return (0, _client.post)('api/v2/teams/' + id + '/join-requests', {
    individual_page_id: page
  }, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  }).then(function (response) {
    return response.team;
  });
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/teams/everydayhero/index.js
// module id = 1338
// module chunks = 0